import { render, staticRenderFns } from "./Shift.vue?vue&type=template&id=28c458c1&scoped=true"
import script from "./Shift.vue?vue&type=script&lang=js"
export * from "./Shift.vue?vue&type=script&lang=js"
import style0 from "./Shift.vue?vue&type=style&index=0&id=28c458c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c458c1",
  null
  
)

export default component.exports